import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { ContractService } from "src/app/contract/shared/contract.service";
import { UserService } from "src/app/shared/user.service";
import { AddSignatoryComponent } from "../contract-form/contract-signature/add-signatory/add-signatory.component";

@Component({
  selector: "app-contract-list",
  templateUrl: "./contract-list.component.html",
  styleUrls: ["./contract-list.component.css"],
})
export class ContractListComponent implements AfterViewInit {
  displayedColumns: string[] = [
    "Contract Name",
    "Contract Type",
    "Created By",
    "Created Date",
    "Last Updated",
    "Status",
    "Action"
  ];

  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  contractList = [];
  filteredData = [];
  isLoading: { [key: string]: boolean } = {};
  alertMessage: string = "";
  showAlertMessage: boolean = false;
  alertColor: string = "";
  currentStatusFilter: string = 'all';

  constructor(
    public contractService: ContractService,
    public userService: UserService,
    private toast: ToastrService,
    private dialog: MatDialog
  ) {
    this.getContract();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  downloadDoc(element): void {
    this.isLoading[element.id] = true;
    this.contractService.downloadPDF(element.id);
    setTimeout(() => {
      this.isLoading[element.id] = false;
      this.toast.success('Contract Downloaded Sucessfully!', '');
    }, 2000);
  }

  ngOnInit() {
    this.contractService.AlertMessage.subscribe((message) => {
      this.alertMessage = message;
      this.showAlertMessage = true;
      this.alertColor = "green";
    });
  }


  openDeleteConfirmation(id): void {
    const dialogRef =
      this.dialog.open(AddSignatoryComponent, {
        enterAnimationDuration: '400ms',
        exitAnimationDuration: '500ms',
        data: {
          id
        }
      });
  }

  async getContract() {
    await this.contractService.getAllContracts().then((allContracts: any) => {
      allContracts.sort((a: any, b: any) => new Date(a.updateDate).getTime() - new Date(b.updateDate).getTime());

      allContracts.forEach((contract: any) => {
        contract.createdDate = moment(contract.createdDate).format("lll")
        contract.updateDate = moment(contract.updateDate).format("lll")
      });

      this.contractList = allContracts;
      this.filteredData = allContracts;
      allContracts.filter((val: any) => {
        return this.userService.permissionsValue[
          "_CONTRACT_" + val.contractType.toUpperCase() + "_VIEW_"
        ];
      });
    });
    this.dataSource.data = this.contractList;

    if (this.sort) {
      this.dataSource.sort = this.sort;
      this.dataSource.sort.active = 'Last Updated';
      this.dataSource.sort.direction = 'desc';
      this.customSortData({
        active: 'Last Updated',
        direction: 'desc'
      } as Sort);
    }
  }

  filterByStatus(status: string) {
    this.currentStatusFilter = status;
    
    if (status === 'all') {
      this.dataSource.data = [...this.filteredData].sort((a, b) => 
        new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
      );
    } else {
      this.dataSource.data = this.filteredData.filter(item => item.status === status);
    }

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  customSortData(event: Sort) {
    const data = this.dataSource.data.slice();
    if (!event.active || event.direction === '') {
      this.dataSource.data = data;
      return;
    }

    this.dataSource.data = data.sort((a, b) => {
      const valueA = (a[event.active] || '').toString().toLowerCase();
      const valueB = (b[event.active] || '').toString().toLowerCase();

      return this.compare(valueA, valueB, event.direction === 'asc');
    });

    // If pagination is present, reset to the first page after sorting
    if (this.paginator) {
      this.paginator.firstPage();
    }
  }


  compare(a: string, b: string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
